import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { AuthProvider } from './service/context/authContext';

import { OrganizationProvider } from './service/context/organizationContext';
import { UserDetailProvider } from './service/context/userDetailContext';
import { UserSummaryProvider } from './service/context/getUserContext';
import { SweepProvider } from './service/context/getSweepContext';
import { NewPlayerProvider } from './service/context/newPlayerContext';
import { NotificationProvider } from './service/context/notificationContext';

// Replace the default title with the one from the environment variable
document.title = process.env.REACT_APP_WEB_TITLE || 'Monitoring';

// Set the favicon and apple-touch-icon to the one from the environment variable
const faviconUrl = `${process.env.REACT_APP_S3_BUCKET_URL}/assets/web_favicon.ico`;
const link: HTMLLinkElement | null =
  document.querySelector("link[rel~='icon']");
if (link) {
  link.href = faviconUrl;
}
const appleTouchLink: HTMLLinkElement | null = document.querySelector(
  "link[rel~='apple-touch-icon']",
);
if (appleTouchLink) {
  appleTouchLink.href = faviconUrl;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <AuthProvider>
    <NotificationProvider>
      <UserDetailProvider>
        <OrganizationProvider>
          <UserSummaryProvider>
            <SweepProvider>
              <NewPlayerProvider>
                <App />
              </NewPlayerProvider>
            </SweepProvider>
          </UserSummaryProvider>
        </OrganizationProvider>
      </UserDetailProvider>
    </NotificationProvider>
  </AuthProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
